import CoreService from './utils/core.service';

const route = 'File';

const FileService = {
    upload: (file) => CoreService.uploadFile(`${route}/attachment`, file),
};

export default FileService;